var chopStickGtmEvents = function () {
    window.dataLayer = window.dataLayer || [];

    $(window.dataLayer).each(function(index) {
        if ($(this)[0].user !== undefined) {
            var user = $(this)[0].user;
            var company = $('body').data('company');
            var companyId = $('body').data('companyid');
            if (company !== undefined) {
                user.company = company;
                user.companyId = companyId;
            }
            window.dataLayer.push({'user': user});
        }
    });

    $(document).on('click', '.js-data-layer-login', function (event) {
        window.dataLayer.push({
            'event': 'login'
        });
    });

    $(document).on('click', '.js-data-layer-logout', function (event) {
        window.dataLayer.push({
            'event': 'logout'
        });
    });

    $(document).on('click', '.js-refund-detail', function (event) {
        window.dataLayer.push({
            'event': 'view_detail'
        });
    });

    $(document).on('click', '.js-data-layer-request-sticky-note', function (event) {
        window.dataLayer.push({
            'event': 'request_stickers'
        });
    });

    $(document).on('click', '.js-data-layer-request-change-profile', function (event) {
        window.dataLayer.push({
            'event': 'change_profile'
        });
    });


    $(document).on('click', '.js-data-layer-register', function (event) {
        window.dataLayer.push({
            'event': 'sign_up'
        });
    });

    $('form[name="frontend_contact"]').find('input.c-button').on('click', function(event) {
        event.preventDefault();
        var subject = $('.js-data-layer-contact-form-subject option:selected').text();
        var subjectId = $('.js-data-layer-contact-form-subject').val();
        var question = $('.js-data-layer-contact-form-question').val();
        var gdprAgree = $('.js-data-layer-contact-form-gdpr').prop('checked');
        var reimbursmentType = $('.js-contact-extra option:selected').text();
        var reimbursmentTypeId = $('.js-contact-extra').val();
        if (subject !== '' && question !== '' && gdprAgree) {
            window.dataLayer.push({
                'event': 'contact_fileupload',
                'subject': subject,
                'subjectId': subjectId,
                'reimbursmentType': reimbursmentType,
                'reimbursmentTypeId': reimbursmentTypeId
            });
        }
    });
};
